var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from "react";
import { defaultTheme } from "../theme/DefaultTheme";
import { styled } from "../theme/ThemeHelpers";
var EmbedContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    max-width: 100%;\n    height: 0;\n    overflow: hidden;\n    padding-bottom: ", "%;\n\n"], ["\n    position: relative;\n    max-width: 100%;\n    height: 0;\n    overflow: hidden;\n    padding-bottom: ", "%;\n\n"])), function (props) { return 100 / props.aspectRatio; });
var IFrame = styled.iframe(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    border: none;\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    border: none;\n"])));
var Embed = React.memo(function (p) {
    var _a = p.autoPlay, autoPlay = _a === void 0 ? true : _a, _b = p.brandedUI, brandedUI = _b === void 0 ? false : _b, _c = p.color, color = _c === void 0 ? defaultTheme.colors.darkGrey : _c, _d = p.hd, hd = _d === void 0 ? true : _d, id = p.id, source = p.source, _e = p.aspectRatio, aspectRatio = _e === void 0 ? 16 / 9 : _e, onClick = p.onClick, url = p.url;
    var videoSource;
    if (url) {
        videoSource =
            {
                id: "",
                source: "youtube"
            };
    }
    else {
        videoSource = { id: id !== null && id !== void 0 ? id : "", source: source !== null && source !== void 0 ? source : "youtube" };
    }
    var uri = videoSource.source === "youtube" ?
        [
            "//www.youtube.com/embed/".concat(videoSource.id),
            '?autohide=true',
            "&amp;autoplay=".concat(autoPlay),
            "&amp;color=".concat(encodeURIComponent(color)),
            "&amp;hq=".concat(hd),
            '&amp;jsapi=false',
            "&amp;modestbranding=".concat(brandedUI),
            "&amp;rel=".concat(brandedUI ? 0 : 1),
        ].join('') :
        [
            "//player.vimeo.com/video/".concat(videoSource.id),
            '?api=false',
            "&amp;autoplay=".concat(autoPlay),
            '&amp;byline=false',
            "&amp;color=".concat(encodeURIComponent(color)),
            '&amp;portrait=false',
            '&amp;title=false',
        ].join('');
    return (React.createElement(EmbedContainer, { aspectRatio: aspectRatio, onClick: onClick },
        React.createElement(IFrame, { allowFullScreen: false, frameBorder: 0, height: "100%", scrolling: "no", src: uri, title: "content from ".concat(source), width: "100%" })));
});
export default Embed;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Embed.js.map